export default "__VITE_ASSET__4c44c7af__"